import React from 'react'
import { isToteSelection } from '@mobi/betslip/helpers/typeGuards'
import type { Selection } from '@mobi/betslip/types'
import { observeImmutable } from '@core/Components/HOCs'
import { Swiper } from '@core/Components/Swiper'
import { isToteSportsSelection } from '@core/Data/Betting/selections'
import { state$ } from '../../driver'
import { Keypad } from './Components/Keypad'
import { KeypadModes } from './Components/Keypad/KeyPress'
import { QuickbetKeypadWrapperStyled } from './Keypad.styles'

interface QuickbetKeypadComponentProps {
  canChangeInvestment: boolean
  isBusy: boolean
  selection: Selection
}

export const QuickbetKeypadComponent = ({
  canChangeInvestment,
  isBusy,
  selection,
}: QuickbetKeypadComponentProps): JSX.Element | null => {
  const isTote = isToteSelection(selection) || isToteSportsSelection(selection)

  return canChangeInvestment ? (
    <QuickbetKeypadWrapperStyled>
      <Swiper usePagination={true}>
        <Keypad disabled={isBusy} allowDecimals showHighStake={!isTote} />
        <Keypad disabled={isBusy} allowDecimals keypadMode={KeypadModes.Numeric} />
      </Swiper>
    </QuickbetKeypadWrapperStyled>
  ) : null
}

export const QuickbetKeypad: React.ComponentClass = observeImmutable(state$, ({ record }) => {
  return <QuickbetKeypadComponent {...record.toJS()} />
})

QuickbetKeypad.displayName = 'QuickbetKeypad'
